 <template>
  <mission />
</template>

<script>
// @ is an alias to /src
import  Mission from "@/components/About/Mission.vue";

export default {
  name: "Home",
  components: {
    Mission,
  },
};
</script>
